import { render } from "./EnrolleeClaimComponent.vue?vue&type=template&id=544d55dc&scoped=true"
import script from "./EnrolleeClaimComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeClaimComponent.vue?vue&type=script&lang=js"

import "./EnrolleeClaimComponent.vue?vue&type=style&index=0&id=544d55dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544d55dc"]])

export default __exports__